import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import Icon from './Icon';
import Backgroud from './Backgroud';
import Ribbon from './Ribbon';

let className = '';
let viewBox = '0 0 78 78';

export default class InteresseIcon extends Component{
	constructor(props) {
		super(props)
	}

	handleClickIcono(){
		if (this.props.link != null) {
			window.location.href = this.props.link;
		}
	}

	getStyle() {
		let width = '100%';
		let height = '100%';

		if (this.props.width != null && this.props.width != "") {
			width = this.props.width;
		}

		if (this.props.height != null && this.props.height != "") {
			height = this.props.height;
		}

		const style = {
			cursor: 'pointer',
			width: width,
			height: height,
			maxWidth: '7rem',
			minWidth: '3.6rem',
		};

		return style;
	}

	render() {
		return (
			<svg
				style={this.getStyle()}
				className={className}
				xmlns="http://www.w3.org/2000/svg"
				viewBox={viewBox}
				xmlnsXlink="http://www.w3.org/1999/xlink"
				onClick={() => this.handleClickIcono()}>

				<Backgroud 
					id_tipo_poliza={this.props.id_tipo_poliza} 
					id_aseguradora={this.props.id_aseguradora} 
					is_mazda={this.props.is_mazda} 
					only_icon={this.props.only_icon}
					id_tipo_auto={this.props.id_tipo_auto}
				/>
				<Icon 
					id_tipo_poliza={this.props.id_tipo_poliza} 
					id_aseguradora={this.props.id_aseguradora} 
					tipo_icono={this.props.tipo_icono}
					only_icon={this.props.only_icon}
					id_tipo_auto={this.props.id_tipo_auto}
				/>
				{/*{this.props.seleccionado ? <Ribbon /> : null}*/}
			</svg>
		)
	}
}

var divs = document.getElementsByClassName('InteresseIcon');
if (divs.length) {
	for (var i = 0; i < divs.length; i++) {
		ReactDOM.render(<InteresseIcon 
			id_tipo_poliza={divs[i].getAttribute('data-id_tipo_poliza')} 
			id_aseguradora={divs[i].getAttribute('data-id_aseguradora')} 
			is_mazda={divs[i].getAttribute('data-is_mazda')} 
			tipo_icono={divs[i].getAttribute('data-tipo_icono')}
			height={divs[i].getAttribute('data-height')} 
			width={divs[i].getAttribute('data-width')} 
			only_icon={divs[i].getAttribute('data-only_icon')}
			/>, 
			divs[i]
		);
	}
}
